import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { MAV_VARIANT_ROUTES } from "./mavVariants";

type CaseTypeOption = "MBO" | "MAV_WAREHOUSE" | "MAV_PRODUCTION" | "MST";

const CASE_TYPE_ROUTES: Record<CaseTypeOption, string> = {
  MBO: "/cases/new",
  MAV_WAREHOUSE: MAV_VARIANT_ROUTES.WarehousePurchasing,
  MAV_PRODUCTION: MAV_VARIANT_ROUTES.Production,
  MST: "/material/new/mst",
};

interface CaseTypeSelectDialogProps {
  open: boolean;
  onClose: () => void;
}

export function CaseTypeSelectDialog({
  open,
  onClose,
}: CaseTypeSelectDialogProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState<CaseTypeOption>("MBO");

  const handleContinue = () => {
    void navigate(CASE_TYPE_ROUTES[selected]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("caseTypeSelect.title")}</DialogTitle>
      <DialogContent>
        <FormControl>
          <RadioGroup
            value={selected}
            onChange={(e) => setSelected(e.target.value as CaseTypeOption)}
          >
            <FormControlLabel
              value="MBO"
              control={<Radio />}
              label={t("caseTypeSelect.mbo")}
            />
            <FormControlLabel
              value="MAV_WAREHOUSE"
              control={<Radio />}
              label={t("caseTypeSelect.mavWarehouse")}
            />
            <FormControlLabel
              value="MAV_PRODUCTION"
              control={<Radio />}
              label={t("caseTypeSelect.mavProduction")}
            />
            <FormControlLabel
              value="MST"
              control={<Radio />}
              label={t("caseTypeSelect.mst")}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.cancel")}</Button>
        <Button onClick={handleContinue} variant="contained">
          {t("caseTypeSelect.continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
